/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from 'gsap';
import imagesLoaded from 'imagesloaded';

const RETURN_KEY = 'ph_team_return';

/**
 * Coming back from a profile (back button or the "Back to the team" links),
 * scroll the roster to the card that was clicked. Runs on fresh loads only;
 * bfcache restores keep their scroll position on their own.
 */
function restoreRosterPosition() {
  let href;
  try { href = sessionStorage.getItem(RETURN_KEY); } catch (e) { return; }
  if (!href) return;

  const nav = performance.getEntriesByType('navigation')[0];
  const fromProfile = /\/team\/[^/]+\/?$/.test(document.referrer) || (nav && nav.type === 'back_forward');
  if (!fromProfile) return;

  const card = Array.from(document.querySelectorAll('.team__link')).find(a => a.href === href);
  if (!card) return;

  const scrollTo = () => card.scrollIntoView({ block: 'center', behavior: 'instant' });
  scrollTo();
  imagesLoaded(card.closest('.team__wrap') || document.body, scrollTo);
  window.addEventListener('load', scrollTo, { once: true }); // after the browser's own #anchor jump
  try { sessionStorage.removeItem(RETURN_KEY); } catch (e) { /* ignore */ }
}

/**
 * Team card -> profile page transition.
 * The card's dark patterned tile expands to fill the viewport, then the
 * browser navigates. The profile page's own .pageOverlay fade handles the
 * reveal on the other side.
 */
export function cardTransition() {
  const bg = document.querySelector('.team__link .team__bg');
  if (!bg) return;
  const bgSrc = bg.getAttribute('src');
  restoreRosterPosition();

  document.addEventListener('click', (e) => {
    const link = e.target.closest('.team__link');
    if (!link) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.target === '_blank') return;

    const tile = link.querySelector('.team__headshots');
    if (!tile) return;

    e.preventDefault();
    try { sessionStorage.setItem(RETURN_KEY, link.href); } catch (err) { /* ignore */ }
    const rect = tile.getBoundingClientRect();
    const expand = document.createElement('div');
    expand.className = 'cardExpand';
    expand.style.cssText = `top:${rect.top}px;left:${rect.left}px;width:${rect.width}px;height:${rect.height}px;`;
    const pattern = document.createElement('div');
    pattern.className = 'cardExpand__pattern';
    pattern.style.backgroundImage = `url(${bgSrc})`;
    expand.appendChild(pattern);
    document.body.appendChild(expand);

    // The dark tile grows; the "WE ARE POOLHOUSE" texture fades away as it does.
    gsap.to(pattern, { opacity: 0, duration: 0.35, ease: 'power2.out' });
    gsap.to('.siteHeader__logo, .hamburger-box', { opacity: 0, duration: 0.3, ease: 'power2.out', overwrite: true });
    gsap.to(expand, {
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight,
      borderRadius: 0,
      duration: 0.55,
      ease: 'power3.inOut',
      onComplete: () => { window.location.href = link.href; },
    });
  });

  // Back/forward cache restores the page with the overlay still in place.
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('.cardExpand').forEach(el => el.remove());
    gsap.set('.siteHeader__logo, .hamburger-box', { clearProps: 'opacity' });
  });
}

